import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { useLocalizedStrings } from "../../localization/LocalizedStringsProvider";
import { fillHeight } from "../../theme";
import ItemList from "../restaurant/ItemList";
import MenuList from "./MenuList";

const Menus = () => {
    const location = useLocation();
    const strings = useLocalizedStrings();
    const app = useAppContext();

    return (
        <Box sx={{ ...fillHeight, overflow: "hidden" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={location.pathname}>
                    <Tab value={`/${app.organizationSlug}/restaurant/menus`} label={strings.menus} component={Link} to={`/${app.organizationSlug}/restaurant/menus`} />
                    <Tab value={`/${app.organizationSlug}/restaurant/items`} label={strings.items} component={Link} to={`/${app.organizationSlug}/restaurant/items`} />
                </Tabs>
            </Box>
            <Box component="main" sx={{ ...fillHeight, overflow: 'hidden', flexGrow: 1, padding: 0 }}>
                <Routes>
                    <Route path="menus" element={<MenuList />} />
                    <Route path="items" element={<ItemList />} />
                </Routes>
            </Box>
        </Box>
    );
};

export default Menus;